export const FIND_MODULES_BY_CARE_PROVIDER_REQUEST = 'FIND_MODULES_BY_CARE_PROVIDER_REQUEST';

export const findModulesByCareProviderRequest = ({
     careProviderId,
     filter = [],
     sorting = { field: 'id', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }) => ({
    type: FIND_MODULES_BY_CARE_PROVIDER_REQUEST,
    payload: { filter, sorting, pagination, careProviderId },
    meta: {
        sorting,
        pagination,
    }
});
